<template lang="html">

  <section class="resultados-competencia">

    <div class="container">

      <h2>
        <span class="-orange">Iner</span>
        <span>tu mejor opción</span>
      </h2>

      <div class="opciones row-start">

        <article class="opcion-el -iner" :full="results.results.length == 0">

          <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-iner-orange.svg" alt="Iner">
          </div>

          <div class="precio">
            <h2>{{results.iner_results.coste}}€</h2>
            <h6>Al mes</h6>
          </div>

          <div class="ahorro" v-if="!!results.iner_results.ahorro">
            <h2>{{results.iner_results.ahorro}}€</h2>
            <h6>De ahorro</h6>
          </div>

          <a class="btn -degree"  @click="sendEventoAnalitycs">Inergízate Ya</a>

        </article>

        <div class="otras-opciones row-start" v-if="results.results.length > 0">

          <h4>¡Iner es <strong>TU MEJOR OPCIÓN!</strong> A continuación te indicamos cuánto pagarías de más con las tarifas online de otras compañías.</h4>

          <div class="opciones-list row-start">

          <article class="opcion-el" v-for="el in results.results">

            <div class="contenedor-imagen row-center">
              <img :src="el.logo" alt="Iner">
            </div>
            
            <div class="precio" v-for="tarifa in el.tarifas">
              <h4>{{tarifa.tarifa_name}}</h4>
              <h2>+{{tarifa.diferencia}}€</h2>
              <h6>+ Caro Al año</h6>
              <h5 class="description" v-if="tarifa.description">*{{tarifa.description}}</h5>
            </div>
          </article>

          </div>

        </div>

      </div>

    </div>


    <img src="/static/img/confeti.gif" class="confeti">

  </section>

</template>

<script lang="js">
  export default  {
    name: 'competencia',
    props: ['results'],
    methods :{
      sendEventoAnalitycs(){
        let that = this;
        this.$ga.event({
          eventCategory: 'Inergizate',
          eventAction: 'abrir',
          eventLabel: 'simulador',
          eventValue: 2
        });

        this.$router.push('/inergizate');
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .resultados-competencia{
    padding: 50px 0;
    background: #f9f7fc;
    position: relative;
    margin-top: 100px;
    padding-bottom: 100px;
    .confeti{
      position: absolute;
      right: 0;
      bottom: -20px;
    }
  }
  
  h2{
    text-align: left;
  }


  .opciones{
    align-items: flex-start;
  }

  .otras-opciones{
    width: 100%;
    max-width: calc(100% - 380px);
    align-items: flex-start;

    h4{
      text-align: left;
      font-size: 20px;
      margin-bottom: 20px;
    }
  }

  .opciones-list{
    width: 100%;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }

  .opcion-el{
    background: white;
    text-align: center;
    margin-right: 20px;
    width: calc(33.33333% - 13.4px);
    padding: 20px;
    position: relative;
    z-index: 2;
    margin-bottom: 20px;

    &:nth-child(3n){
      margin-right: 0;
    }

    &.-iner{
      padding: 40px;
      border-style: solid;
      border-width: 3px;
      border-image-source: linear-gradient(to left, #f6a910, #f0800e 49%, #eb5f0c);
      border-image-slice: 1;
      max-width: 360px;
      margin-bottom: 0px;
      position: relative;
      width: 100%;

      &[full=true]{
        max-width: 100%;
      }

      .btn{
        position: absolute;
        bottom: 0;
        left: 50%;
        min-width: 220px;
        transform: translate(-50%,50%);
      }

    }

    .contenedor-imagen{
      height: 60px;
      width: 100%;
      margin-bottom: 10px;

      img{
        max-width: 100%;
        max-height: 100%;
        display: inline-block;
      }
    }
    


    h6{
      text-transform: uppercase;
      font-weight: 300;
      color: $purple;
      font-size: 18px;
    }

    .description{
      font-size: 10px;
      width: 100%;
      text-align: center;
      display: block;
    }

    .precio{
      margin-top: 10px;
      &:first-of-type{
        margin-top: 0;
      }
      h2{
        color: $orange;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 40px;
        width: 100%;
        text-align: center;
        margin-bottom: 0;
        line-height: 45px;
      }

      h4{
        font-size: 14px;
        text-transform: uppercase;
        color: $purple;
        margin-bottom: 0;
        width: 100%;
        text-align: center;
      }
    }
    
    &.-iner{
      .precio{
        margin-bottom: 20px;
        h2{
          font-size: 60px;
          line-height: 60px;
        }
      }
    }


    .ahorro{
      h2{
        color: $dark;
        margin-bottom: 0;
        font-size: 60px;
        font-weight: 800;
        text-align: center;
        line-height: 60px;
      }
    }

  }


  @media screen and (max-width: 1023px){


    .opcion-el{
      &.-iner{
        max-width: 300px;
      }
    }

    .otras-opciones{
      max-width: calc(100% - 320px);
    }

  }


  @media screen and (max-width: 950px){

    .opcion-el.-iner{
      max-width: 50%;
      margin-right: 20px;
    }

    .otras-opciones{
      max-width: calc(50% - 20px);

      .opcion-el{
        width: calc(50% - 10px);

        &:nth-child(2n){
          margin-right: 0;
        }

        &:nth-child(2n-1){
          margin-right: 20px;
        }
      }

    }

  }



  @media screen and (max-width: 768px){


    .opcion-el.-iner{
      margin-bottom: 40px;
      max-width: 100%;
      margin-right: 0;
    }

    .otras-opciones{
      max-width: 100%;
    }

  }

  @media screen and (max-width: 420px){
   .otras-opciones{
    .opcion-el{
      width: 100%;
      &:nth-child(2n-1){
        margin-right: 0px;
      }
    }

  }
}


</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/resultados-competencia.vue